export enum ParticipantStatus {
  READY = 'ready',
  STARTED = 'started',
  TIME_UP = 'time_up',
  HELP_REQUESTED = 'help_requested',
  WAITING = 'waiting',
  FINISHED = 'finished',
  ASSESSMENT_COMPLETE = 'assessment_complete',
}